import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row g-sm-4 g-3" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexWishlist',
  setup(__props) {

const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const wishList = defineAsyncComponent(() => import("@/components/theme/ecommerce/whishlist/wishList.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ecommerce",
      title: "Wishlist"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card9), {
          colClass: "col-sm-12",
          cardhaderClass: "title-header",
          title: "Wishlist"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(wishList))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})